import Header from "../components/Header";
import Footer from "../components/Footer";

const Contacts = () => {
  return (
    <div>
      <Header />
      <h1 className="page-heading">Contacts</h1>
      <p className="page-paragraph">...</p>
      <Footer />
    </div>
  );
};

export default Contacts;
